module.exports = __webpack_public_path__ + "media/images/landing_pages/sprite-b2e21ba68747504229cfb1862b6ca00d.svg";